/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  var trackedTechnicalErrors = {};

  function sendClarity(command, value, secondaryValue) {
    if (typeof window.clarity !== 'function') {
      return;
    }

    if (typeof secondaryValue === 'undefined') {
      window.clarity(command, value);
    } else {
      window.clarity(command, value, secondaryValue);
    }
  }

  function pushEvent(eventName, details) {
    var payload = details || {};
    payload.event = eventName;
    payload.event_version = '1';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    sendClarity('event', eventName);
  }

  function productDetails(extra) {
    var product = window.theme && window.theme.product;
    var details = {
      product_id: product ? String(product.id) : '',
      product_handle: product ? product.handle : '',
      variant_id: product && product.variantId ? String(product.variantId) : '',
      currency: product ? product.currency : '',
      value: product && typeof product.price === 'number' ? product.price / 100 : null
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        details[key] = extra[key];
      });
    }

    return details;
  }

  function reportTechnicalError(diagnostic) {
    if (!diagnostic || !diagnostic.errorType || !diagnostic.sourceCategory) {
      return;
    }

    var key = diagnostic.errorType + ':' + diagnostic.sourceCategory;

    if (trackedTechnicalErrors[key]) {
      return;
    }

    trackedTechnicalErrors[key] = true;
    pushEvent('shba_js_error', {
      error_type: diagnostic.errorType,
      source_category: diagnostic.sourceCategory
    });
    sendClarity('event', 'shba_js_error_' + diagnostic.errorType + '_' + diagnostic.sourceCategory);
  }

  window.__shbaReportTechnicalError = reportTechnicalError;
  (window.__shbaTechnicalErrorQueue || []).forEach(reportTechnicalError);
  window.__shbaTechnicalErrorQueue = [];

  function initializeProductTracking() {
    if (!window.theme || !window.theme.product) {
      return;
    }

    sendClarity('set', 'product_handle', window.theme.product.handle);
    sendClarity('set', 'technical_release', '2026-08-24');
    pushEvent('shba_product_view', productDetails());

    document.addEventListener('change', function (event) {
      var target = event.target;

      if (!target || !target.matches('.SizeSwatch__Radio, .shba-sticky-atc__option--size select')) {
        return;
      }

      sendClarity('set', 'selected_size', target.value);
      pushEvent('shba_size_selected', productDetails({
        selected_size: target.value,
        option_position: target.getAttribute('data-option-position') || ''
      }));
    });

    document.addEventListener('product:added', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant || {};

      pushEvent('shba_add_to_cart', productDetails({
        variant_id: variant.id ? String(variant.id) : productDetails().variant_id,
        quantity: detail.quantity || 1
      }));
    });

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;

      if (!variant) {
        return;
      }

      window.theme.product.variantId = variant.id;
      window.theme.product.price = variant.price;
    });
  }

  function initializeCheckoutTracking() {
    document.addEventListener('click', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') {
        return;
      }

      var checkoutControl = event.target.closest('[name="checkout"], a[href*="/checkout"]');

      if (!checkoutControl) {
        return;
      }

      pushEvent('shba_checkout_start', productDetails({
        source: checkoutControl.closest('#sidebar-cart, .Drawer') ? 'cart_drawer' : 'cart_page'
      }));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductTracking);
  } else {
    initializeProductTracking();
  }

  initializeCheckoutTracking();
}());
